module.exports = __webpack_public_path__ + "img/play-button.258a9379.svg";